import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: 'img[appCompanyLogo]',
  standalone: true
})
export class CompanyLogoDirective implements OnInit, OnChanges, OnDestroy {
  /**
   * Primary domain (identifier)
   * Example: apple.com
   */
  @Input() domain!: string;

  /**
   * Height in pixels (e.g. 45 for Search)
   */
  @Input() height = 45;

  /**
   * Width in pixels (e.g. 45 for Search)
   */
  @Input() width = 45;

  /**
   * Existing logo URL from partner API
   */
  @Input() fallbackLogoUrl?: string;

  /**
   * Final static fallback
   */
  @Input() placeholderUrl = '../../../../../assets/images/placeholder.png';

  private attemptedFallback = false;
  private removeErrorListener?: () => void;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.removeErrorListener = this.renderer.listen(this.el.nativeElement, 'error', () => {
      this.handleError();
    });

    this.updateSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['domain'] || changes['width'] || changes['height'] || changes['fallbackLogoUrl']) {
      this.updateSource();
    }
  }

  ngOnDestroy(): void {
    if (this.removeErrorListener) {
      this.removeErrorListener();
      this.removeErrorListener = undefined;
    }
  }

  private updateSource(): void {
    this.attemptedFallback = false;
    if (!this.domain) {
      this.setFinalFallback();
      return;
    }

    const brandfetchUrl = this.buildBrandfetchUrl();
    this.renderer.setAttribute(this.el.nativeElement, 'src', brandfetchUrl);
  }

  private buildBrandfetchUrl(): string {
    const key = environment.brandfetchKey;
    return `${environment.brandfetchUrl}${this.domain}/w/${this.width}/h/${this.height}/fallback/404/type/icon?c=${key}`;
  }

  private handleError(): void {
    // First failure → fallback to existing partner logo
    if (!this.attemptedFallback && this.fallbackLogoUrl) {
      this.attemptedFallback = true;
      this.renderer.setAttribute(
        this.el.nativeElement,
        'src',
        this.fallbackLogoUrl
      );
      return;
    }

    // Second failure → static placeholder
    this.setFinalFallback();
  }

  private setFinalFallback(): void {
    this.renderer.setAttribute(
      this.el.nativeElement,
      'src',
      this.placeholderUrl
    );
  }

}
